var map = {
	"./Ok_are_you_ready.mp3": "a07a",
	"./Ok_are_you_ready_short.mp3": "1abc",
	"./ahhh-ngean.mp3": "a61e",
	"./black_in_black_ac_dc_x_dang.mp3": "280d",
	"./bpen à-rai gan.mp3": "7613",
	"./bàep née rîak wâa chon chìng dtee-chìng.mp3": "fcb3",
	"./bàep née rîak wâa lia hĕe.mp3": "a38d",
	"./chamkraburng.mp3": "74e4",
	"./chom-rom kon chôp mĕe.mp3": "f4e5",
	"./dang-kee-yes.mp3": "ead8",
	"./dang-surprise.mp3": "3ee5",
	"./doo dtàe mĕe.mp3": "9aa4",
	"./doo gan mâng rĕu bplào.mp3": "9bb9",
	"./doo tam-má-tam moh mâng dí doo bpràt-yaa kam kom wí-tĕe chee-wít bpà-ràt-yom kòm jai kòm gì-làyt dtan-hăa.mp3": "c487",
	"./dtaai láew pûak tân muay goo maa lá laa gòn doo mĕe bpai gòn pŏm jà doo muay.mp3": "fe6e",
	"./dtà-gohn hăa săn-hăa dtàe mĕe.mp3": "3d88",
	"./dtà-gohn hăa săn-hăa.mp3": "41ac",
	"./dàp-bêrn hĕe.mp3": "e180",
	"./dòot kwăa dòot sáai.mp3": "da57",
	"./dòot nom nòi.mp3": "be89",
	"./goo mee sŏng-hĕe.mp3": "a89d",
	"./grà dâo-kon-née têe grà dâo-kon-née tee.mp3": "6470",
	"./gôr bpen oh gàat an-dee têe pŏm jà ao bayn CLH hâa-săam maa tàai tam-má.mp3": "0eed",
	"./have-room-have-condom.mp3": "30a6",
	"./hóie kon têe năi pûak tân bpen kon jang-wàt à-rai gèrt wan năi gèrt bpee năi gèrt bpee jor rĕu bpee à-rai kráp pŏm mâi kâo jai.mp3": "8c49",
	"./hôie dtaai láew.mp3": "be62",
	"./hôie.mp3": "fa8b",
	"./hĕe-hŏm hĕe-a-long  hĕe-a-long mâak loie nâa lia.mp3": "5a71",
	"./hĕn láew yang têe hĕn née keu pláat-dtìk têe kwăeng pâa.mp3": "c0c5",
	"./india-sound.mp3": "089c",
	"./intro_dang.mp3": "aaec",
	"./joob-meng.mp3": "6301",
	"./jà-rern nai tam.mp3": "37fe",
	"./jàt maa ao bàep-bêrm nâ keu leu nâ.mp3": "8350",
	"./kiminoto.mp3": "904d",
	"./krai jà bpai lia hĕe măa lia hĕe kon lia hĕe mŏo hĕe kwaai goo mâi róo dtàe goo chôp lia hĕe kon.mp3": "75b8",
	"./la_mun_kra_tug.mp3": "f1f9",
	"./man bpen yàang née dtông mee ù-bpà-gon.mp3": "7a01",
	"./man dee măi.mp3": "1c72",
	"./mee hĕe meen-má-née.mp3": "9303",
	"./mâi kâo jai loie jing jing loie.mp3": "7818",
	"./mâi kâo jai loie pûak tân bpen yang ngai.mp3": "a4e3",
	"./mâi kâo jai.mp3": "035c",
	"./măai kwaam wâa ngai nîa kon jang-wàt năi kon jang-wàt à-rai pûak tân nîa.mp3": "79af",
	"./mĕe rá ngóp gan táng wan táng keun loie.mp3": "5446",
	"./ngîan jing jà-ríng.mp3": "89b4",
	"./ngîan wói.mp3": "5220",
	"./nhaaa_ni.mp3": "a78e",
	"./nuu-ruu-na-wa-pee.mp3": "3380",
	"./née bpen gaan sà-daeng hâi doo ná tân pôo jà-rern.mp3": "75e4",
	"./née bpen gaan sŏn tam-má ná pôo jà-rern.mp3": "69b0",
	"./omae_wa_mou_shindeiru.mp3": "481d",
	"./ph_intro.mp3": "f617",
	"./prór hĕe man hŏm dee.mp3": "af23",
	"./pŏm mâi kâo jai jing loie.mp3": "a434",
	"./pŏm mâi kâo jai loie jing jing.mp3": "9073",
	"./sa-wa-dee-kub.mp3": "78bf",
	"./sound_animal_made.mp3": "1634",
	"./startup.mp3": "be29",
	"./sà-wàt-dee kráp.mp3": "3483",
	"./sòng bpai hâi láew gôr yang jà hâi doo èek.mp3": "26ba",
	"./tam ngaan mee dtàe mĕe plòh maa táng wan loie.mp3": "26a1",
	"./tam ngaan táng wan lá mĕe plòh táng wan loie.mp3": "a175",
	"./tam-má grà-dtùk jì-dòk rá chaa jai.mp3": "74a4",
	"./tob-mook.mp3": "b875",
	"./trong née kor hĕe hĕe trong nun kor hĕe hĕe nee kor hĕe nun kor hĕe took took tée kor hĕe hĕe.mp3": "6d7f",
	"./tum-pai-tum-mai.mp3": "b360",
	"./táng dèk táng pôo yài.mp3": "785a",
	"./táng wan loie wan nîa.mp3": "7884",
	"./tâa meung chôp lia hĕe măa meung gôr lia bpai bpai.mp3": "1113",
	"./tâa taang yàang née rîak wâa grà dâo kôo.mp3": "3fba",
	"./tâa yàang née rîak wâa dòot nom.mp3": "5720",
	"./tân pôo jà-rern sêung mâak bpai dûay bpan-yaa.mp3": "7e61",
	"./tân sà-maa-chík.mp3": "54b8",
	"./wan prá wan jâo mâi wáyn gan lóie.mp3": "bd7d",
	"./wan-prá-yài ná.mp3": "4b70",
	"./where are you.mp3": "6744",
	"./yamete_kudasai.mp3": "dda2",
	"./yàak jà doo dtàe mĕe.mp3": "449d",
	"./yìp òk maa yìp òk maa.mp3": "b1a9",
	"./กล้าขัดคำสั่งผมเหรอ.mp3": "3abb",
	"./กูน่ะแก่แล้ว_แต่กูยังโคยแข็ง.mp3": "1a75",
	"./กูรู้คนมันเกลียดกู_มันไม่ชอบกู.mp3": "ba4f",
	"./กูแก่แล้วไอ้สัส.mp3": "f693",
	"./ขอเซ็ท.mp3": "a4a3",
	"./ดูดเจี๊ยว.mp3": "e1d4",
	"./ที่เห็นนี้คือพลาสติก.mp3": "1d3e",
	"./บูมชิคกะบูม.mp3": "a4df",
	"./พร้อมไหม.mp3": "3bd0",
	"./พูดได้ไหม.mp3": "9977",
	"./มอมอมอมอมอ.mp3": "5037",
	"./รู้สึกคันที่ไข่.mp3": "7d36",
	"./ลี่_อันยอง.mp3": "b72e",
	"./ลี่ขอดมยาดมก่อน.mp3": "2bb3",
	"./ลี่ขอเม้า.mp3": "04db",
	"./วอเอเอเอวอเอ.mp3": "3bf1",
	"./วิโรจน์ก้าวไก่.mp3": "7783",
	"./หวัดดีครับผมคือจุ้บเหม่ง.mp3": "0889",
	"./อื้มมมม_อาหร่อยย.mp3": "cda2",
	"./อเวจี/760เสียไม่ได้หรือคะ.mp3": "cb12",
	"./อเวจี/คืนไม่ได้ค่ะ.mp3": "7c97",
	"./อเวจี/คุกเข่าสิ่คะ.mp3": "7645",
	"./อเวจี/คุกเข่าแล้วกราบแล้วให้พิชซ่าเราฟรีเดี๋ยวนี้.mp3": "e7aa",
	"./อเวจี/ช่วยตัวเองหน่อยสิ่คะ.mp3": "b07f",
	"./อเวจี/ตกอเวจีปอยเปตแสนล้านภพ.mp3": "746a",
	"./อเวจี/สองแสนล้านภพสองแสนล้านชาติยืนนิ่งๆ.mp3": "d84d",
	"./อเวจี/ห้ามแตะตัวพระผู้เป็นเจ้านะคะ.mp3": "7675",
	"./อเวจี/เดินออกประตูไปค่ะ.mp3": "d67e",
	"./เกินปุยมุ้ย.mp3": "60bb",
	"./เก่งเจ๋ง.mp3": "1bee",
	"./เก่งแต่เรื่องคนอื่น.mp3": "2016",
	"./เจี๊ยกค่อก.mp3": "d102",
	"./เจ๋งแจ๋ว😂.mp3": "b484",
	"./เป็นกล้วยอะไร.mp3": "1228",
	"./เป็นล้านเลยเหรอพี่.mp3": "32a6",
	"./เหมียวๆ.mp3": "eb85",
	"./เฮ้อไอ้เหี้ย.mp3": "5e31",
	"./แบลบๆ.mp3": "c44e",
	"./แบ๊ะๆ.mp3": "c6e8",
	"./แม่งโง่หรือฉลาดวะ.mp3": "d9ac",
	"./แลกปีกกับหาง.mp3": "54a6",
	"./โฮ่งๆ.mp3": "93c1",
	"./ไอ้หน้าหมี.mp3": "6d95"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c3e4";